export const PENSION_ANALYSIS = 'PENSION_ANALYSIS';
export const PENSION_ANALYSIS_CALCULATION_REQUEST = 'PENSION_ANALYSIS_CALCULATION_REQUEST';
export const PENSION_ANALYSIS_CALCULATION_SUCCESS = 'PENSION_ANALYSIS_CALCULATION_SUCCESS';
export const PENSION_ANALYSIS_CALCULATION_FAIL = 'PENSION_ANALYSIS_CALCULATION_FAIL';
export const PENSION_ANALYSIS_CALCULATION_RESET = 'PENSION_ANALYSIS_CALCULATION_RESET';
